import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { getStringWithUpperFirstChar } from '../../../functions/getStringWithUpperFirstChar'
import { NavLink } from 'react-router-dom'
import { getFormatedData } from '../../../functions/getFormatedData'
import { colors } from '../../../styles/colors'

const Container = styled.aside`
    .sidebar {
        width: 250px;
        
        border: 1px solid ${colors.dark_blue};

        padding: 1.25rem;
        padding-bottom: 4rem;
        margin-right: 5rem;
        margin-bottom: 5rem;

        display: flex;
        flex-direction: column;

        @media (max-width: 767.98px) {
            display: none;
        }
        
        // INCLUDED CLASSES:

        .sidebar-category-link {
            font-family: 'Lato', sans-serif;
            font-weight: 300;
            font-size: 1.75rem;
            line-height: 121%;
            letter-spacing: 0.05em;
            text-decoration: none;
            color: ${colors.dark_blue};

            :hover {
                color: ${colors.red};
            }
        }
        .links-block {
            margin: .75rem 0;
        }
        .lvl-0 {
            margin-bottom:.751rem;
        }
        .link-active {
            color: ${colors.red};
        }        
        .sidebar-category-link + div {
            display: none;
        }
        .link-active + div {
            display: block;
        }
    }
    
`

export const SidebarNavigation = () => {

    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const outputed_categories = sortCategoriesForSidebarMenu(categories)
    const root_categories = outputed_categories.filter(category => category.lvl === 0)

    return (
        <Container>
            <div className="sidebar">
                {
                    root_categories
                        ? root_categories.map( category => (
                            <SidebarLinkBlock key={category.key} parent_category={category} categories={outputed_categories} />
                        ))
                        : null
                }
            </div>
        </Container>
    )
}

function sortCategoriesForSidebarMenu(categories) {
    const outputed_categories = []

    function sortCategoriesRecursFunction(parent_name, lvl, parent_path) {
        categories.forEach(category => {
            if (parent_name === category.parent_category_name) {
                const name = category.category_name
                const path = parent_path + '/' + name
                const newData = { ...category, lvl, path }
                outputed_categories.push(newData)

                lvl++
                sortCategoriesRecursFunction(name, lvl, path)
                lvl--
            }
        })

    }

    function sortCategoriesForSidebarMainFunction() {
        let lvl = 0;
        let path = ''

        categories.forEach(category => {
            if (!category.parent_category_name) {
                const name = category.category_name
                const current_path = path + name
                const newData = { ...category, lvl, path: current_path }
                outputed_categories.push(newData)

                lvl++
                sortCategoriesRecursFunction(name, lvl, current_path)
                lvl--

            }
        })
    }

    sortCategoriesForSidebarMainFunction()

    return outputed_categories
}

function SidebarLinkBlock ({parent_category, categories}) {

    const marginLeft = parent_category.lvl + 'rem'

    return (
        <div className={`links-block lvl-${parent_category.lvl}`} style={{marginLeft: marginLeft}}>
            <NavLink
                to={`/products/${parent_category.path}`}
                key={parent_category.key}
                activeClassName='link-active'
                className={`sidebar-category-link`} >
                {getStringWithUpperFirstChar(parent_category.category_name)}
            </NavLink>
            <div>
                {categories.map( category => category.parent_category_name === parent_category.category_name ? <SidebarLinkBlock key={category.key} parent_category={category} categories={categories} /> : null)}
            </div>
        </div>
    )
}
